import { createRoute } from '@signal/router';
export var HOME = createRoute();
export var NOT_FOUND = createRoute('not-found');
export var LOGIN = createRoute('login');
export var LOGOUT = createRoute('logout');
export var UNAUTHORIZED = createRoute('unauthorized');
export var PROFILE = createRoute('profile');
export var ACCOUNTS = createRoute(PROFILE, 'accounts');
export var ACCOUNT = createRoute('account/:accountId');